import { request } from "./APIservice";
import { URL_GET_UNIQA_AGE_PRICES } from "../config/env";
import { GET } from "../utils/constants/api";

export default class ProductsService {
  static getProductName(code, language = "bg") {
    switch (code) {
      case "CSC+GO":
        switch (language) {
          case "bg":
            return "Каско + Гражданска";
          case "en":
            return "Casco Insurance + MTPL";
          default:
            return "";
        }
      case "GO":
        switch (language) {
          case "bg":
            return "Гражданска отговорност";
          case "en":
            return "MTPL";
          default:
            return "";
        }
      case "CSC":
        switch (language) {
          case "bg":
            return "Автокаско";
          case "en":
            return "Casco Insurance";
          default:
            return "";
        }
      case "TRA":
        switch (language) {
          case "bg":
            return "Пътуване в чужбина";
          case "en":
            return "Travel Insurance";
          default:
            return "";
        }
      case "PRP":
        switch (language) {
          case "bg":
            return "Застраховка имущество";
          case "en":
            return "Property Insurance";
          default:
            return "";
        }
      case "MTN":
        switch (language) {
          case "bg":
            return "Планинска застраховка";
          case "en":
            return "Mountain Insurance";
          default:
            return "";
        }
      case "EXT":
        switch (language) {
          case "bg":
            return "Екстремни спортове";
          case "en":
            return "Extreme sports";
          default:
            return "";
        }
      case "HLT":
        switch (language) {
          case "bg":
            return "Здравна застраховка - Уника";
          case "en":
            return "Health Insurance";
          default:
            return "";
        }
      case "FHLT":
        switch (language) {
          case "bg":
            return "ЗДРАВНА ЗАСТРАХОВКА ЗА ЧУЖДЕНЦИ";
          case "en":
            return "Health Insurance For Foreigners";
          default:
            return "";
        }
      case "LFE":
        switch (language) {
          case "bg":
            return "Срочна Застраховка Живот";
          case "en":
            return "Life Insurance";
          default:
            return "";
        }

      case "LFI":
        switch (language) {
          case "bg":
            return "Инвестиционна Застраховка Живот";
          case "en":
            return "Investment Life Insurance";
          default:
            return "";
        }

      case "HWP":
        switch (language) {
          case "bg":
            return "Здравна застраховка - Метлайф";
          case "en":
            return "Health with Priority";
          default:
            return "";
        }
      case "HCL":
        switch (language) {
          case "bg":
            return "Международна здравна застраховка";
          case "en":
            return "International insurance HEALTH CLUB";
          default:
            return "";
        }
      case "CI":
        switch (language) {
          case "bg":
            return "Фирмена Застраховка Живот";
          case "en":
            return "Company Insurance Life";
          default:
            return "";
        }
      case "HIS":
        switch (language) {
          case "bg":
            return "История на щети";
          case "en":
            return "Damage history";
          default:
            return "";
        }
      case "GOV":
        return "Гражданска отговорност - вноски";
      case "KID":
        return "Детска";
      case "MED":
        return "Лечение без Граници";
      case "GLO":
        switch (language) {
          case "bg":
            return "Проверка за Глоби от КАТ";
          case "en":
            return "Check for Traffic Fines";
          default:
            return "";
        }
      case "KLE":
        switch (language) {
          case "bg":
            return "Кредитни консултации";
          case "en":
            return "Credit counseling";
          default:
            return "";
        }
      case "VIGCHECK":
        switch (language) {
          case "bg":
            return "ПРОВЕРКА ЗА ВИНЕТКА";
          case "en":
            return "VIGNETTE CHECK";
          default:
            return "";
        }
      case "VIG":
        switch (language) {
          case "bg":
            return "Купи Винетка";
          case "en":
            return "Buy Vignette";
          default:
            return "";
        }
      case "CRH":
        switch (language) {
          case "bg":
            return "Проверка за щети";
          case "en":
            return "Check for damage";
          default:
            return "";
        }
      case "HealthProducts":
        switch (language) {
          case "bg":
            return "Здравни застраховки";
          case "en":
            return "Health insurances";
          default:
            return "";
        }
      case "LifeProducts":
        switch (language) {
          case "bg":
            return "ЗАСТРАХОВКИ ЖИВОТ";
          case "en":
            return "Life Insurances";
          default:
            return "";
        }
      case "CompanyProducts":
        switch (language) {
          case "bg":
            return "ФИРМЕНИ ЗАСТРАХОВКИ";
          case "en":
            return "Company Insurances";
          default:
            return "";
        }
      case "AutoProducts":
        switch (language) {
          case "bg":
            return "АВТОМОБИЛНИ ЗАСТРАХОВКИ";
          case "en":
            return "Auto Insurances";
          default:
            return "";
        }
      case "ChieldProducts":
        switch (language) {
          case "bg":
            return "ДЕТСКИ ЗАСТРАХОВКИ";
          case "en":
            return "CHILDREN'S INSURANCE";
          default:
            return "";
        }
      case "CHCL":
        switch (language) {
          case "bg":
            return "ЗДРАВНА ЗАСТРАХОВКА БУЛСТРАД";
          case "en":
            return "Corporate health insurance HEALTH CLUB";
          default:
            return "";
        }
      case "HCEF":
        switch (language) {
          case "bg":
            return "Допълнително Здравно";
          case "en":
            return "Additional health insurance Bulstrad";
          default:
            return "";
        }
      case "GOCHECK":
        switch (language) {
          case "bg":
            return "Проверка За Гражданска";
          case "en":
            return "Check for Civil Liability";
          default:
            return "";
        }
      case "GTPCHECK":
        switch (language) {
          case "bg":
            return "ПРОВЕРКА ЗА ТЕХНИЧЕСКИ ПРЕГЛЕД";
          case "en":
            return "GTP CHECK";
          default:
            return "";
        }
      default:
        return "";
    }
  }

  static async getQuniqaPrices() {
    try {
      const response = await request(GET, URL_GET_UNIQA_AGE_PRICES, {}, null, null, true);
      const { data } = response || {};
      return data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
}
